<template>
  <div>
    <b-row>
      <b-col cols="12">
        <vue-good-table
          ref="tabelaEmpresas"
          :columns="colunas"
          :rows="dadosTabela"
          row-style-class="clickable"
          :select-options="{
            enabled: true,
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true,
            selectAllByGroup: true,
          }"
          theme="view"
          @on-selected-rows-change.capture="selecaoAlterada"
        >
          <!-- no records -->
          <div slot="emptystate">
            <p style="text-align:center; margin:0">
              Nenhum registro foi encontrado.
            </p>
          </div>
        </vue-good-table>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.view {
  .vgt-inner-wrap {
    box-shadow: none !important;
  }
}

.main-menu.menu-dark .navigation > li ul li > a {
  padding: 8px 10px 8px 12px;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'TabelaEmpresa',
  components: {
    VueGoodTable,
  },
  props: {
    modeloId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      carregando: false,
      colunasInner: [],
      busca: '',
      linhasSelecionadas: [],
      dadosTabela: [],
      colunas: [
        { label: 'Inscrição', field: 'cadastroFederal', width: '150px' },
        { label: 'Nome', field: 'razaoSocial', width: '250px' },
      ],
    }
  },
  created() {
    this.getEmpresas()
  },
  methods: {
    selecaoAlterada(params) {
      this.$emit('empresa-selecionada', params.selectedRows)
    },
    getEmpresas() {
      apiEmpresa.getEmpresasPorModelo(this.modeloId).then(payload => {
        this.dadosTabela = payload.data
      }).catch(error => {
        throw error
      })
    },
  },
}
</script>
